const getSelectedColor = (variant) => variant?.selectedOptions?.find(
    (option) => option.name?.toLowerCase() === "color",
)?.value;

const getVariantImageUrl = (variant) => variant?.image?.url?.url ?? variant?.image?.url;

const getVariantImageStartIndex = (images, variant) => {
    const variantImageUrl = getVariantImageUrl(variant);
    if (variantImageUrl) {
        const urlIndex = images.findIndex((image) => image.node?.url === variantImageUrl);
        if (urlIndex >= 0) return urlIndex;
    }

    const variantImageId = variant?.image?.id;
    if (variantImageId) {
        return images.findIndex((image) => image.node?.id === variantImageId);
    }

    return -1;
};

const filterImagesByColor = (images, selectedVariant, product) => {
    if (!images?.length || !selectedVariant) return images;

    const variantStarts = (product?.variants?.edges ?? [])
        .map((variant) => ({
            color: getSelectedColor(variant.node),
            position: getVariantImageStartIndex(images, variant.node),
        }))
        .filter((entry) => entry.position >= 0)
        .sort((first, second) => first.position - second.position);

    if (!variantStarts.length) return images;

    const selectedColor = getSelectedColor(selectedVariant.node);
    const selectedIndex = variantStarts.findIndex(
        (entry) => entry.color?.toLowerCase() === selectedColor?.toLowerCase(),
    );
    if (selectedIndex === -1) return images;

    const startIndex = variantStarts[selectedIndex].position;
    const endIndex = variantStarts[selectedIndex + 1]
        ? variantStarts[selectedIndex + 1].position - 1
        : images.length - 1;

    return images.slice(startIndex, endIndex + 1);
};

export default filterImagesByColor;
